import React from 'react';
import StatsListItem from './ListItem';
import constants from '../../constants';

const {STATS_HEADER} = constants;

const StatsList = ({stats, user}) => {
  return (
    <div className="container_stats">
      <table className="stats_table">
        <tr>
          {STATS_HEADER.map(headerItem => (
            <th
              key={headerItem.title}
              className={headerItem.className}>
              {headerItem.title}
            </th>
          ))}
        </tr>
        {stats.map(item => (
          <StatsListItem
            key={item.id}
            item={item}
            user={user}
          />
        ))}
      </table>
    </div>
  );
};

export default StatsList;



// WEBPACK FOOTER //
// ./src/components/StatsLocker/List.js